// extracted by mini-css-extract-plugin
export default {"webContainer":"Container_webContainer__jqKlA","container":"Container_container__SWp0D"};